var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"progress is-large",style:({
      backgroundColor: _vm.color,
      width: _vm.long ? _vm.data.percentage + '%' : 'fit-content',
    })},[_c('span',[_vm._v("\n      "+_vm._s(_vm.currency)+" "+_vm._s(_vm.decimal(_vm.data.cost))+"\n      "),_c('small',[_vm._v(_vm._s(_vm.decimal(_vm.data.consumption))+" kWh")])]),_c('span',{staticStyle:{"margin-left":"10px"}},[_vm._v(_vm._s(_vm.data.percentage.toFixed(0))+"%")])])])}
var staticRenderFns = []

export { render, staticRenderFns }